import { createContext, useContext } from 'react'

interface OfferPageAssistantLayoutContextValue {
  collapsedPortalElement?: HTMLElement
  isLayoutEligible: boolean
  portalElement?: HTMLElement
  onAvailabilityChange: (available: boolean) => void
}

const OfferPageAssistantLayoutContext = createContext<OfferPageAssistantLayoutContextValue | undefined>(undefined)

export const OfferPageAssistantLayoutProvider = OfferPageAssistantLayoutContext.Provider

export function useOptionalOfferPageAssistantLayout() {
  return useContext(OfferPageAssistantLayoutContext)
}
